import { render, staticRenderFns } from "./initDataGl.vue?vue&type=template&id=55753868&scoped=true"
import script from "./initDataGl.vue?vue&type=script&lang=js"
export * from "./initDataGl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55753868",
  null
  
)

export default component.exports